/**
* Represents codename of Kentico Cloud element types
*/
export enum ElementType {
    Text = 'text',
    Number = 'number',
    ModularContent = 'modular_content',
    Asset = 'asset',
    DateTime = 'date_time',
    RichText = 'rich_text',
    MultipleChoice = 'multiple_choice',
    UrlSlug = 'url_slug',
    Taxonomy = 'taxonomy',
    Custom = 'custom',
    Unknown = 'unknown'
}
